import React, { useContext, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import ContactForm from './ContactForm';
import ContactUsForm from './ContactUsForm';
import ActivityContext from '../context/ActivityContext';
import RegisterInterestForm from './RegisterInterestForm';
import { useLocation } from '@gatsbyjs/reach-router';
const { townNamesMatch } = require('../util/util');
const ModularHumanHelpForm = ({ data }) => {
  const { contactSubmitted, setContactSubmitted } = useContext(ActivityContext);
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const { backgroundColor, noTopPadding, noBottomPadding, heading } = data;
  const queryData = query();
  const location = useLocation();
  const inBuildTown = location.state?.inBuildTown;

  const networkCoverage = queryData.allDatoCmsNetworkCoverageModel.nodes.find(
    (coverage) =>
      coverage.areaName &&
      inBuildTown &&
      townNamesMatch(coverage.areaName, inBuildTown),
  );
  const region = networkCoverage?.region;

  return (
    <div className={`modular-human-help-form-container ${backgroundColor}`}>
      <div
        className={`modular-global-width modular-heading-secondary ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <RegisterInterestForm
          selectedAddress={selectedAddress}
          isHumanHelp={true}
          setSelectedAddress={setSelectedAddress}
          region={region}
          isModularBlock={true}
          successPath={location.pathname.replace(/^\/+/g, '')}
        />
      </div>
    </div>
  );
};

export default ModularHumanHelpForm;
export const fragment = graphql`
  fragment ModularHumanHelpForm on DatoCmsHumanHelpForm {
    internal {
      type
    }
    id
    backgroundColor
    noTopPadding
    noBottomPadding
    heading {
      value
    }
  }
`;
export const query = () =>
  useStaticQuery(graphql`
    {
      allDatoCmsNetworkCoverageModel {
        nodes {
          inBuild
          areaName
          available
          region
        }
      }
    }
  `);
